import styled from 'styled-components';

export const StyledStartDateField = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-left: 0.5rem;
  }

  .start-date-container {
    margin-bottom: 0;
  }

  .form-field-container {
    width: 0;
    height: 0;
  }

  .react-datepicker-wrapper {
    visibility: hidden;
    pointer-events: none;
    width: 0;
    height: 0;
    padding-bottom: 1rem;
  }

  input {
    display: none;
  }

  .glyphicon {
    display: none;
  }
`;
